import { Box } from "@mui/material";
import { H1 } from "../components/Typography";

const SilvertopBanner = () => {
  return (
    <Box
      sx={{
        borderRadius: 5,
        display: {
          md: "flex",
          xs: "none",
        },
        justifyContent: "space-between",
        alignItems: "center",
        background: "linear-gradient(90deg, #B8D0FF 0%, #FFEFCF 100%)",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
        },
      }}
    >
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "40%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "20%",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/goldcoins.svg"
        alt="saas-dasboard-footer"
      />

      <Box
        justifyContent="center"
        textAlign="center"
        sx={{
          width: {
            xs: "80%",
            sm: "80%",
            md: "55%",
          },
          paddingY: {
            xs: 2,
            sm: 2,
            md: 5,
          },
        }}
      >
        <H1
          fontSize={24}
          fontWeight={600}
          sx={{
            textAlign: "center",
            fontFamily: "'Poppins', sans-serif",
            background: "#f00",
          }}
          color="#000"
        >
          Make your wealth shine with digital silver investments
        </H1>
      </Box>
      <Box
        component="img"
        sx={{
          height: {
            xs: "60%",
            sm: "60%",
            md: "55%",
          },
          width: {
            xs: "60%",
            sm: "60%",
            md: "16%",
          },
          display: {
            xs: "none",
            md: "block",
          },
        }}
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/silvercoins.svg"
        alt="saas-dasboard-footer"
      />
    </Box>
  );
};

export default SilvertopBanner;
